// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__AGIij","content":"dashboard_content__DmEtW","row":"dashboard_row__GjP63","logo":"dashboard_logo__w8zhg","image":"dashboard_image__bCYwx"};